var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.show == true)?_c('div',[_c('a',{attrs:{"href":_vm.banner.clickUrl,"target":"_blank"}},[_c('img',{staticClass:"w-100",attrs:{"src":_vm.banner.imgUrl}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }